enum MedicareStarRatingTypeEnum {
  Five = "5",
  FourPointFive = "4.5",
  Four = "4",
  ThreePointFive = "3.5",
  Three = "3",
  TwoPointFive = "2.5",
  Two = "2",
  NA = "N/A",
}

export { MedicareStarRatingTypeEnum };
